import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from './components/SEOHead';

export default function Home() {
  return (
    <>
      <SEOHead />
      <main>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Clients />
        <Partners />
        <Contact />
        <Footer />
      </main>
    </>
  );
}
